import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["title"];
  static values = {
    threshold: { type: Number, default: 96 },
  };

  // Starts watching scroll position so the project title can become sticky.
  // Called automatically by Stimulus when data-controller="sticky-project-title" connects.
  connect() {
    this.ticking = false;
    this.handleScroll = this.handleScroll.bind(this);

    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.update();
  }

  // Stops watching scroll position when this controller leaves the page.
  // Called automatically by Stimulus before the controller disconnects.
  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  // Schedules a single title update for the current animation frame.
  // Called by the window scroll event listener registered in connect().
  handleScroll() {
    if (this.ticking) return;

    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  // Toggles the stuck title class once the page scrolls beyond the threshold.
  // Called by connect() and handleScroll().
  update() {
    if (!this.hasTitleTarget) return;

    this.titleTarget.classList.toggle(
      "project-title-stuck",
      window.scrollY >= this.thresholdValue,
    );
  }
}
